module.exports = __webpack_public_path__ + "static/img/defultBG1.f872946.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/defultBG1.png
// module id = U3Ec
// module chunks = 1